exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:768px){.table_heading[data-v-5b607b72]{margin-top:20px}tbody td[data-v-5b607b72]:before{content:attr(data-th) \": \";background:#79beed;color:#fff;margin-right:10px;padding:2px 10px;font-weight:400!important}table td[data-v-5b607b72]{padding:0}tr[data-v-5b607b72]{border-bottom:2px solid #e4ebeb;margin-top:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b607b72","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/mlang/church/calendar/spring.vue
// module id = uJQI
// module chunks = 0